module.exports = __webpack_public_path__ + "img/symbol_1.72e0f2a9.png";